<div class="arcc-attachments">
    @if (loading) {
        <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
    }

    @if (!loading && editMode()) {
        <div class="mb-3">
            <span>Drag files onto the site to upload them there. Drop files elsewhere to attach them to the email or
                <button class="ace-btn btn-link btn-sm"
                        tabindex="0"
                        (click)="uploadFile(null); $event.stopPropagation()"
                        (keydown.enter)="uploadFile(null); $event.stopPropagation()">
                    Select a File...
                </button>
            </span>
        </div>
    }

    @if (!loading && availableSites.length === 0) {
        <div class="text-muted p-2">No sites available.</div>
    }

    @if (!loading && availableSites.length > 0) {
        <accordion [closeOthers]="false" [isAnimated]="true">
            @for (site of availableSites; track site.siteId) {
                <accordion-group [(isOpen)]="site.isOpen"
                                 (isOpenChange)="site.isOpen && loadSiteAttachments(site)"
                                 wsFileDrop
                                 [dropDisabled]="!editMode()"
                                 (filesDropped)="onFilesDropped(site, $event)">
                    <!-- Accordion heading -->
                    <div class="d-flex" style="border: none;" accordion-heading>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <div class="d-flex align-items-center">
                                <panel-chevron [showBody]="site.isOpen"></panel-chevron>
                                <span class="site-name ms-2">{{ site.siteName }}</span>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                @if (editMode()) {
                                    <button class="ace-btn btn-link btn-sm"
                                            tabindex="0"
                                            (click)="uploadFile(site); $event.stopPropagation()"
                                            (keydown.enter)="uploadFile(site); $event.stopPropagation()">
                                        Select a File...
                                    </button>
                                }
                                <entity-attachments buttonClass="btn-sm has-icon btn-secondary"
                                                    [(hasAttachments)]="site.hasAttachments"
                                                    [modalData]="site.modalData"
                                                    [uploadFile]="site.uploadFile"
                                                    (allAttachmentsChange)="onSiteAttachmentsChanged(site, $event)">
                                </entity-attachments>
                            </div>
                        </div>
                    </div>

                    <!-- Accordion body: attachment list with checkboxes -->
                    <div class="attachment-list">
                        @if (site.attachmentsLoading) {
                            <div class="text-center p-2">
                                <ws-ace-loader [inline]="true"></ws-ace-loader> Loading attachments...
                            </div>
                        }

                        @if (!site.attachmentsLoading && site.attachments.length === 0) {
                            <div class="text-muted p-2">No attachments for this site.</div>
                        }

                        @for (attachment of site.attachments; track attachment.attachmentID) {
                            <div class="checkbox">
                                <label class="attachment-row d-flex py-1" [class.disabled]="!editMode()">
                                    <input type="checkbox"
                                           class="me-2"
                                           [disabled]="!editMode()"
                                           [checked]="attachment.selected"
                                           (change)="toggleAttachmentSelection(site, attachment)" />
                                    <span class="attachment-name">{{ attachment.fileName }}
                                        .{{ attachment.fileExtension }}</span>
                                </label>
                            </div>
                        }
                    </div>
                </accordion-group>
            }
        </accordion>
    }

    <!-- Hidden file input for upload -->
    <input #fileInput
           type="file"
           class="d-none"
           (change)="onFileInputChange($event)" />
</div>
